"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.5,24H4.5a.5.5,0,0,1,0-1h15a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.56,20.56A1.5,1.5,0,0,1,14.5,21H3v.5a.5.5,0,0,0,.5.5h17a.5.5,0,0,0,.5-.5V15.12Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.5,0H2.5A.5.5,0,0,0,2,.5v19a.5.5,0,0,0,.5.5h12a.49.49,0,0,0,.35-.15l7-7A.49.49,0,0,0,22,12.5V.5A.5.5,0,0,0,21.5,0ZM15,18.29V13h5.29Z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.52,12.9a.24.24,0,0,0-.23-.15H15a.25.25,0,0,0-.25.25v5.29a.24.24,0,0,0,.15.23.2.2,0,0,0,.1,0,.26.26,0,0,0,.18-.07l5.29-5.29A.26.26,0,0,0,20.52,12.9Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.56,15.57a1,1,0,0,1-1-1V4.85a1,1,0,1,1,2,0v9.72A1,1,0,0,1,11.56,15.57Z",
    style: {
      fill: '#fff'
    }
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.42,10.71H6.69a1,1,0,0,1,0-2h9.73a1,1,0,0,1,0,2Z",
    style: {
      fill: '#fff'
    }
  }));
};

exports["default"] = _default;